import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Icon } from '../../../subcomponents/icon/icon';
const b = bemClassBuilder('v-member-payment-card-wallet-add-card-button');
export const MemberPaymentCardWalletAddCardButton = observer(props => {
    const { onClick, disabled, iconName, label } = props;
    return (_jsxs("button", Object.assign({ className: b.block(), onClick: onClick, disabled: disabled }, { children: [_jsx(Icon, { name: iconName, className: b.element('add-card-icon') }), _jsx("span", Object.assign({ className: b.element('add-card-label') }, { children: label }))] })));
});
MemberPaymentCardWalletAddCardButton.displayName = 'MemberPaymentCardWalletAddCardButton';
